import React, { useEffect, useState } from "react";
import Layout from "../../../../app/Layout";
import HeaderContent from "../../General/HeaderContent";
import Breadcrumb from "../../General/Breadcrumb";
import UpdateObservationsReporte from "../../../components/Formularios/UpdateObservationsReporte";
import TableReport from "../../reportes/reportesExcel/TableReport";
import ModalBasic from "../../../components/Modals/ModalBasic";
import ModalLarge from "../../../components/Modals/ModalLarge/ModalLarge";
import TablaNotaDiscente from "../../../components/Tablas/TablaNotaDiscente";
import SpinnerLoading from "../../../components/Spinners/SpinnerLoading";
import * as moment from "moment";

import "../../reportes/generalPosventa.scss";
//Redux
import { connect } from "react-redux";
import {
  listarReporteGeneralTutor,
  listarNotasDiscente,
  obtenerMisProyectosTutor,
} from "../../../../actions/reportesActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

// Progreso académico de los alumnos, para el tutor logueado: mismo dashboard
// que usa EXPCLIENTE en /reporte/seguimiento (GeneralPosventa.js), pero acotado
// a los diplomados que el tutor tiene asignados. Se carga un diplomado a la vez
// (el reporte es pesado: ~1 min por diplomado con varios cientos de alumnos).
const ProgresoTutor = (props) => {
  const { cantidadesTotales, reporte, loading } = props;
  const { listarReporteGeneralTutor, listarNotasDiscente } = props;

  const [dataReporte, setDataReporte] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalLarge, setShowModalLarge] = useState(false);
  const [reporteEstudiante, setReporteEstudiante] = useState({});
  const [misProyectos, setMisProyectos] = useState([]);
  const [cargandoProyectos, setCargandoProyectos] = useState(true);
  const [proyectoSel, setProyectoSel] = useState('');

  const cambiarProyecto = (e) => {
    const idProyecto = e.target.value;
    setProyectoSel(idProyecto);
    if (idProyecto) listarReporteGeneralTutor(idProyecto);
  };

  const guardarReporte = (report) => {
    setReporteEstudiante(report);
    setShowModal(true);
  };

  const verNotasSesiones = (idMatriculaDiscente) => {
    listarNotasDiscente(idMatriculaDiscente);
    setShowModalLarge(true);
  };

  const calcularRitmo = (cumplimiento, report) => {
    const sinData = !report.promedio_final && !report.cant_asistidas && !report.puntos_adicionales;
    if (sinData) return 'SIN DATA';
    if (cumplimiento >= 90) return 'AL DÍA';
    if (cumplimiento >= 75) return 'PREVENTIVO';
    if (cumplimiento >= 50) return 'ATRASADO';
    return 'CRÍTICO';
  };

  const calcularSemaforo = (report, cumplimiento) => {
    const sinData = !report.promedio_final && !report.cant_asistidas;
    if (sinData) return 'GRIS';
    if (report.pago === 'MOROSO' && report.cant_asistidas > 0) return 'ROJO';
    if (report.pago === 'MOROSO' && !report.cant_asistidas) return 'GRIS';
    if (cumplimiento >= 90) return 'VERDE';
    return 'AMBAR';
  };

  useEffect(() => {
    const reporteData = reporte || [];
    const dataGenerado = reporteData.map((report, index) => {
      const notaAlumno = parseFloat(report.promedio_final) || 0;
      const sesDesarrolladas = Number(report.cant_se_realizada_programa || 0);
      const sesTotales = Number(report.cant_total_sesiones_programa || 1);
      const notaOptima = sesTotales > 0
        ? Math.min(20, parseFloat(((sesDesarrolladas / sesTotales) * 20).toFixed(2)))
        : parseFloat(report.promedio_optimo) || 20;
      const puntosMax = parseFloat(report.puntos_maximos_disponibles) || 0;
      const cumplimiento = notaOptima > 0 ? Math.min(100, Math.round((notaAlumno / notaOptima) * 100)) : 0;

      return {
        id: index + 1,
        id_matricula_proyecto: report.id_matricula_proyecto,
        color_estado: calcularSemaforo(report, cumplimiento),
        proyecto: report.nombre_proyecto,
        nombre: report.nombre_usuario,
        apellido: report.apellido_usuario,
        dni: report.dni,
        correo: report.email,
        telefono: report.celular,
        pago: report.pago || '---',
        importe_deuda: (report.importe_deuda || 0).toFixed(2),
        cant_total_sesiones: report.cant_total_sesiones,
        cant_se_realizada: report.cant_se_realizada,
        cant_asistidas: report.cant_asistidas,
        promedio_optimo: notaOptima,
        promedio_final: notaAlumno,
        cumplimiento: cumplimiento,
        progreso: cumplimiento,
        ritmo: calcularRitmo(cumplimiento, report),
        fecha_edicion: report.fecha_edicion ? moment(report.fecha_edicion).format("DD MMM YYYY") : "---",
        hora_edicion: report.fecha_edicion ? moment(report.fecha_edicion).format("LTS") : "---",
        turno: report.turno,
        estado_pago: report.pago,
        observaciones: report.observaciones || "No hay observaciones",
        estado_academico:
          report.id_estado_est === 1 ? "Activo"
          : report.id_estado_est === 2 ? "Ambar"
          : report.id_estado_est === 3 ? "Desertado" : "",
        puntos_adicionales: report.puntos_adicionales || 0,
        puntos_inedi: report.puntos_evaluacion || 0,
        total_puntos: report.total_puntos || 0,
        puntos_maximos_disponibles: puntosMax,
        inedirank: report.inedirank,
        button: (
          <Button type="button" variant='info' size='xs' onClick={() => guardarReporte(report)}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        ),
      };
    });
    setDataReporte(dataGenerado);
  }, [reporte]);

  useEffect(() => {
    obtenerMisProyectosTutor()
      .then(({ data }) => setMisProyectos(data?.proyectos || []))
      .catch(() => setMisProyectos([]))
      .finally(() => setCargandoProyectos(false));
  }, []);

  const sesionesRealizadasPrograma = Number(reporte?.[0]?.cant_se_realizada_programa || 0);
  const totalSesionesPrograma = Number(reporte?.[0]?.cant_total_sesiones_programa || 0);

  const porcentajeAvancePrograma =
    totalSesionesPrograma > 0
      ? Math.min(100, Math.round((sesionesRealizadasPrograma / totalSesionesPrograma) * 100))
      : 0;

  const NOTA_MAXIMA = 20;
  const notaIdealActual = totalSesionesPrograma > 0
    ? Math.min(20, parseFloat(((sesionesRealizadasPrograma / totalSesionesPrograma) * 20).toFixed(2)))
    : 20;
  const porcentajeNotaIdeal = Math.min(100, Math.round((notaIdealActual / NOTA_MAXIMA) * 100));

  const sinProyectosAsignados = !cargandoProyectos && misProyectos.length === 0;

  return (
    <Layout>
      <HeaderContent title="Progreso" icon="insert_chart_outlined" />
      <Breadcrumb
        link={[
          { url: "/inicio", nombre: "Inicio", icon: "fas fa-home" },
          { url: "", nombre: "Tutoría" },
          { url: "", nombre: "Progreso" },
        ]}
      />
      <div className="general-posventa">
        {sinProyectosAsignados ? (
          <div className="box box-secondary p-4 text-center text-muted">
            No tienes diplomados/programas asignados todavía.
          </div>
        ) : (
          <>
            <div className="box p-3 mb-3">
              <div className="row">
                <div className="col-md-6 filtro">
                  <label htmlFor="filtro-proyecto-tutor"><strong>Diplomado/Programa</strong></label>
                  <select
                    id="filtro-proyecto-tutor"
                    className="form-control"
                    value={proyectoSel}
                    onChange={cambiarProyecto}
                    disabled={cargandoProyectos}
                  >
                    <option value="">
                      {cargandoProyectos ? 'Cargando...' : '-- Selecciona un diplomado --'}
                    </option>
                    {misProyectos.map((p) => (
                      <option key={p.id_proyecto} value={p.id_proyecto}>
                        {p.nombre_proyecto}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {!proyectoSel ? (
              <div className="box box-secondary p-4 text-center text-muted">
                Selecciona un diplomado para ver su progreso.
              </div>
            ) : (
              <>
                <div className="row my-3">
                  <div className="col-md-6">
                    <div className="avance-programa">
                      <div className="avance-programa__info">
                        <span>Avance de clases</span>
                        <strong>{porcentajeAvancePrograma}%</strong>
                      </div>
                      <div className="avance-programa__barra">
                        <div className="avance-programa__progreso" style={{ width: `${porcentajeAvancePrograma}%` }} />
                      </div>
                      <div className="avance-programa__detalle">
                        {sesionesRealizadasPrograma} de {totalSesionesPrograma} clases desarrolladas
                      </div>
                    </div>

                    <div className="avance-programa mt-2">
                      <div className="avance-programa__info">
                        <span>Nota ideal</span>
                        <strong>{notaIdealActual.toFixed(2)} / {NOTA_MAXIMA}</strong>
                        <span style={{ fontSize: '11px', color: '#888', marginLeft: '8px' }}>Nota óptima: {NOTA_MAXIMA}</span>
                      </div>
                      <div className="avance-programa__barra">
                        <div className="avance-programa__progreso" style={{ width: `${porcentajeNotaIdeal}%`, background: '#3498db' }} />
                      </div>
                      <div className="avance-programa__detalle">
                        {porcentajeNotaIdeal}% alcanzado sobre nota máxima de {NOTA_MAXIMA}
                      </div>
                    </div>
                  </div>
                </div>

                <SpinnerLoading loading={loading}>
                  <div className="box box-secondary">
                    <h5 className="p-3 d-flex align-items-center mb-0" style={{ color: "#434343" }}>
                      <i className="fas fa-list pr-2"></i>Lista de estudiantes
                    </h5>
                    <div className="box-body">
                      <TableReport rows={dataReporte} verNotasSesiones={verNotasSesiones} />
                      <div style={{ marginTop: '15px', padding: '8px', display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ fontSize: '16px', margin: '8px' }}>
                          <span style={{ fontWeight: 'bold' }}>Total de Discentes:</span> {cantidadesTotales?.cant_discentes ?? 0}
                        </div>
                        <div style={{ fontSize: '16px', margin: '8px' }}>
                          <span style={{ fontWeight: 'bold' }}>Total Rojos:</span> {cantidadesTotales?.discentes_rojo ?? 0}
                        </div>
                        <div style={{ fontSize: '16px', margin: '8px' }}>
                          <span style={{ fontWeight: 'bold' }}>Total Ambar:</span> {cantidadesTotales?.discentes_ambar ?? 0}
                        </div>
                        <div style={{ fontSize: '16px', margin: '8px' }}>
                          <span style={{ fontWeight: 'bold' }}>Total Verde:</span> {cantidadesTotales?.discentes_verde ?? 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </SpinnerLoading>
              </>
            )}
          </>
        )}
      </div>
      <ModalLarge title="Notas" show={showModalLarge} updateModalLarge={setShowModalLarge}>
        <TablaNotaDiscente />
      </ModalLarge>
      <ModalBasic show={showModal} updateShowModal={setShowModal} title="Reporte estudiante">
        <UpdateObservationsReporte
          reporte={reporteEstudiante}
          proyectos={misProyectos.filter((p) => String(p.id_proyecto) === String(proyectoSel))}
        />
      </ModalBasic>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  cantidadesTotales: state.reporte.cantidadesTotales,
  reporte: state.reporte.reporte,
  loading: state.reporte.loading,
});

const mapDispatchToProps = {
  listarReporteGeneralTutor,
  listarNotasDiscente,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgresoTutor);
